import { useMutation } from '@tanstack/react-query';
import { shopifyApi, type ConnectShopifyRequest } from 'services';

export const useConnectShopify = () => {
  const connectMutation = useMutation({
    mutationFn: (request: ConnectShopifyRequest) => shopifyApi.connectStore(request),
  });

  return {
    connectShopify: connectMutation.mutateAsync,
    isConnecting: connectMutation.isPending,
    connectionError: connectMutation.error,
  };
};